document.addEventListener('DOMContentLoaded', () => {
    // slick default setting
    let defaulsettings = {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.swiper-prev',
            prevEl: '.swiper-next'
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    };

    // start slider default
    let allSwipper =[];

    document.querySelectorAll('.swiper-slider').forEach((element,i) => {

        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`,"");
        let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwipper[i] = swiper;

    });

    let quadReviews = new Swiper('.reviews__slider',{
        speed: 1000,
        loop: true,
        spaceBetween: 40,
        navigation: {
            prevEl: '.reviews-prev',
            nextEl: '.reviews-next',
        },
        autoplay: {
            delay: 9000,
            disableOnInteraction: false
        }
    });

    let sliderLeft = new Swiper('.gallery-quad__slider-left',{
        loop: true,
        speed: 800,
        slidesPerView: 1,
        allowTouchMove: false,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        }
    });

    let sliderCenter = new Swiper('.gallery-quad__slider-center',{
        loop: true,
        speed: 800,
        slidesPerView: 1,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl: '.gallery-arrow-prev',
            nextEl: '.gallery-arrow-next'
        },
        pagination: {
            el: '.gallery-center-pagination',
            clickable: true
        }
    });

    let sliderRight = new Swiper('.gallery-quad__slider-right',{
        loop: true,
        speed: 800,
        slidesPerView: 1,
        allowTouchMove: false,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        }
    });

    sliderCenter.controller.control = [sliderLeft,sliderRight];

    let singleSlider = new Swiper('.slider__slider',{
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl: '.quad-slider-prev',
            nextEl: '.quad-slider-next'
        }
    });

    document.querySelectorAll('.all-rooms__slider').forEach((element, i) => {
        let entryId = element.getAttribute('data-entry');
        element.setAttribute(`data-room-swiper-${i}`, "");
        let swiper = new Swiper(`[data-room-swiper-${i}]`,{
            loop: true,
            speed: 700,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            navigation: {
                prevEl: `.room-${entryId}-prev`,
                nextEl: `.room-${entryId}-next`
            }
        });
    });
});